import { getReq } from '../utils/request'
import { Response } from '../types/api'
import { Calendar } from '../types/data'

export default {
	loadCalendar: (filters: object): Response<Calendar> => getReq('/api/admin/calendar', filters)
}
